import React, { useContext } from "react";
import ProfileCommonEdit from "./Common/Edit";
import { AuthContext, IntlContext } from "context";
import ProfileCompanyEdit from "./Company/Edit";
import { Role } from "types/user";
import Button from "ui/Button";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";

interface Props {
    onEditSubmitSuccess: () => void;
    onClickHandleMode: () => void;
}

const Edit: React.FC<Props> = ({ onEditSubmitSuccess, onClickHandleMode }) => {
    const { account, currentRole } = useContext(AuthContext);
    const intl = useContext(IntlContext);

    if (Role.COMPANY === account!.user.roles[0]) {
        return (
            <React.Fragment>
                <div className="flex flex--justify-content-flex-end">
                    <Button className="btn btn--primary" onClick={onClickHandleMode}>
                        <Icon icon={{ prefix: "fas", iconName: "pencil" }} className="icon--left" />
                        Fermer l'édition du profil
                    </Button>
                </div>
                <ProfileCompanyEdit onEditSubmitSuccess={onEditSubmitSuccess} />
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <div className="flex flex--justify-content-flex-end">
                <Button className="btn btn--primary" onClick={onClickHandleMode}>
                    <Icon icon={{ prefix: "fas", iconName: "pencil" }} className="icon--left" />
                    {intl.formatMessage("generic.action.cancel")}
                </Button>
            </div>
            {(currentRole === Role.PROVIDER || currentRole === Role.CLIENT) && (
                <ProfileCommonEdit onEditSubmitSuccess={onEditSubmitSuccess} />
            )}
        </React.Fragment>
    );
};

export default Edit;
